module.exports = __webpack_public_path__ + "media/passed60Sound.2126a308.wav";